export enum UserPreferenceKeysEnums {
  RosterSorting = 'rosterSorting',
  RosterEmployeeNameDisplay = 'rosterEmployeeNameDisplay',
  RosterEmployeeGridSourceCostCenter = 'rosterEmployeeGridSourceCostCenter',
  RosterEmployeeGridDestinationCostCenter = 'rosterEmployeeGridDestinationCostCenter'
}

export enum UserPreferenceValueEnums {
  Show = 'show',
  Hide = 'hide'
}
